module.exports = __webpack_public_path__ + "static/media/S3N8-6.a586331e.svg";